import { Button, Grid } from "@mui/material"
import { isEmpty, map } from "lodash"
import React from "react"
import { Attachment } from "@mui/icons-material"
import { AttachedFileFragment } from "@/graphql/generated/graphql";
import { ACCEPTED_ATTACHMENT_FORMATS } from "@/utils/constants";
import UploadPreviewItem from "./UploadPreviewItem";
import { VisuallyHiddenInput } from "@/theme/styled-components";

interface ImageSectionProps {
  attachments: AttachedFileFragment[];
  handleRemoveImage: (id: string) => void;
  disableAttaching: boolean;
  isUploading: boolean;
  hasImages: boolean;
  handleUploadImage: (e: React.ChangeEvent<HTMLInputElement>) => void;
}
const ImageSection: React.FC<ImageSectionProps> = ({ attachments, handleRemoveImage, handleUploadImage, disableAttaching, hasImages, isUploading }) => {
  return (
    <Grid container spacing={2}>
      <Grid size={12}>
        <Button
          component="label"
          variant="contained"
          tabIndex={-1}
          startIcon={<Attachment />}
          sx={{ marginTop: 1 }}
          disabled={disableAttaching}
        >
          Attach
          <VisuallyHiddenInput
            type="file"
            accept={ACCEPTED_ATTACHMENT_FORMATS}
            onChange={handleUploadImage}
            disabled={disableAttaching}
          />
        </Button>
      </Grid>
      {hasImages && (
        <Grid size={12}>
          {!isEmpty(attachments) &&
            map(attachments, (attachment, index) => (
              <UploadPreviewItem
                file={attachment}
                isUploading={isUploading}
                key={`${index}-${attachment.id}`}
                onRemove={() => handleRemoveImage(attachment.id)}
              />
            ))
          }
        </Grid>
      )}
    </Grid>
  );
}

export default ImageSection
